import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';

// Menu "..." de ações secundárias/destrutivas (§2/§12: ação diária visível,
// ação ocasional no menu, ação destrutiva no menu + confirmação). Sempre
// para propagação de clique — nunca dispara a navegação da linha/drawer por
// trás. `itens`: [{ label, onClick, tone: 'danger'|undefined, disabled, hint }]
export function RowMenu({ itens, label = 'Mais ações' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('click', onClickOutside);
    return () => document.removeEventListener('click', onClickOutside);
  }, []);

  const itensVisiveis = (itens || []).filter((i) => i.visivel !== false);
  if (itensVisiveis.length === 0) return null;

  return (
    <div className="crm-dropdown" ref={ref} onClick={(e) => e.stopPropagation()}>
      <button type="button" className="crm-icon-btn" title={label} aria-label={label} onClick={() => setOpen((v) => !v)}>
        <FontAwesomeIcon icon={faEllipsis} />
      </button>
      {open && (
        <div className="crm-dropdown-menu align-left">
          {itensVisiveis.map((item) => (
            <button
              key={item.label}
              type="button"
              className="crm-dropdown-item"
              disabled={item.disabled}
              title={item.disabled ? item.hint : undefined}
              style={item.tone === 'danger' ? { color: 'var(--crm-danger)' } : undefined}
              onClick={() => { setOpen(false); item.onClick(); }}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default RowMenu;
